<template>

    <nav class="col-md-2 d-none d-md-block bg-light sidebar">
        <i :class="showSidebarIcon" @click="hideSidebarClicked()" v-b-tooltip.hover.right title="Hide menu"></i>
        <div class="sidebar-sticky">
            <ul class="nav flex-column">
                <li>
                    <router-link class="nav-link"
                                 exact-active-class="active"
                                 :to="'/dashboard'">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                </li>
                <li v-if="userHasAccess(claimsRoles)">
                    <router-link class="nav-link"
                                 exact-active-class="active"
                                 :to="'/messages'">
                        <i class="fas fa-inbox"></i> Inbox Unassigned
                    </router-link>
                </li>
            </ul>
            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span>Buckets</span>
                <a class="d-flex align-items-center text-muted" href="#">

                </a>
            </h6>
            <ul class="nav flex-column">
                <li v-for="(item, index) in items"
                    :key="index">
                    <router-link class="nav-link"
                                 v-if="userHasAccess(item.viewByRoles)"
                                 exact-active-class="active"
                                 :to="item.to">
                        <i :class="getbucketIcon(item.to)"></i> {{item.label}} <span v-if="item.new === true" class="badge badge-pill badge-success">NEW</span>
                    </router-link>
                </li>
            </ul>

            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span>Other</span>
                <a class="d-flex align-items-center text-muted" href="#">

                </a>
            </h6>
            <ul class="nav flex-column  mb-2">
                <li v-for="(query, index) in queries"
                    :key="index">
                    <router-link v-if="userHasAccess(query.viewByRoles)"
                                 class="nav-link"
                                 exact-active-class="active"
                                 :to="query.to">
                        <i :class="getbucketIcon(query.to)"></i> {{query.label}} <span v-if="query.new === true" class="badge badge-pill badge-success">NEW</span>
                    </router-link>
                </li>
            </ul>

            <div v-if="!hideSysAdmin">
                <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                    <span>System Admin</span>
                    <a class="d-flex align-items-center text-muted" href="#">
                        <span data-feather="plus-circle"></span>
                    </a>
                </h6>
                <ul class="nav flex-column  mb-2">
                    <li v-for="(query, index) in admin"
                        :key="index">
                        <router-link class="nav-link"
                                     exact-active-class="active"
                                     :to="query.to">
                            <i :class="getbucketIcon(query.to)"></i> {{query.label}}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

</template>

<script>

    import authentication from '@/mixins/authentication.js'
    import userRoles from '@/constants/userRoles.js'
    const systemAdminRoles = [1001]
    const claimsRoles = [1009, 1010, 1011, 1012]
    const financeRoles = [1008,1001,1012]
    const dataEntryRoles = [1014]
    export default {
        name: 'Sidebar',
        mixins: [
            authentication
        ],
        data: () => {
            return {
                manShowSidebar: true,
                //hideSysAdmin: true,
                items: [
                    {
                        label: 'Inbound Emails',
                        to: '/buckets/claimunreadmessages',
                        viewByRoles: claimsRoles
                    },
                    {
                        label: 'New Claims (GADGET)',
                        to: '/buckets/bucket0',
                        viewByRoles: [...claimsRoles, ...dataEntryRoles]
                    },
                    {
                        label: 'New Claims (TIGA)',
                        to: '/buckets/bucket1',
                        viewByRoles: [...claimsRoles, ...dataEntryRoles]
                    },
                    {
                        label: 'New Claims (POLICE FED)',
                        to: '/buckets/policefed',
                        viewByRoles: claimsRoles
                    },
                    {
                        label: 'Claims (FT Review)',
                        to: '/buckets/bucket2',
                        viewByRoles: claimsRoles
                    },
                    {
                        label: 'Excess Card Payments',
                        to: '/buckets/bucket5',
                        viewByRoles: financeRoles
                    },
                    {
                        label: 'Recent Doc Uploads',
                        to: '/buckets/bucket3',
                        viewByRoles: claimsRoles
                    },
                    {
                        label: 'Selected Repair Options',
                        to: '/buckets/bucket6',
                        viewByRoles: claimsRoles
                    },
                    {
                        label: 'Cancelled Repair Options',
                        to: '/buckets/bucket8',
                        viewByRoles: claimsRoles
                    },
                    {
                        label: 'Settlement Options Tasks',
                        to: '/buckets/settlementoptiontasks',
                        viewByRoles: claimsRoles
                    },
                    {
                        label: 'Customer Payments (Finance)',
                        to: '/finance/customerpayments',
                        viewByRoles: financeRoles
                    },
                    {
                        label: 'Supplier Payments (Finance)',
                        to: '/finance/home',
                        viewByRoles: financeRoles
                    }
                ],
                queries: [
                    {
                        label: 'Claims (All)',
                        to: '/buckets/bucket4',
                        viewByRoles: [...claimsRoles, ...financeRoles]
                    },
                    {
                        label: 'Claim Payments (All)',
                        to: '/buckets/finance/claimpayments',
                        viewByRoles: [...claimsRoles, ...financeRoles]
                    },
                    {
                        label: 'Selected Repair Options (All)',
                        to: '/buckets/bucket7',
                        viewByRoles: claimsRoles
                    },
                    {
                        label: 'Excess Card Payments (All)',
                        to: '/buckets/bucket10',
                        viewByRoles: financeRoles
                    },
                    {
                        label: 'Task History (All)',
                        to: '/taskHistory',
                        viewByRoles: [1004]
                    },
                    {
                        label: 'Reports',
                        to: '/reports',
                        viewByRoles: [...claimsRoles, ...financeRoles]
                    },
                    {
                        label: 'Partner Imports',
                        to: '/partnerimports',
                        viewByRoles: claimsRoles
                    }
                ],
                admin: [
                    {
                        label: 'Rule Components',
                        to: '/rulecomponents'
                    },
                    {
                        label: 'Pipelines',
                        to: '/pipelines'
                    },
                    {
                        label: 'Reseller Pipelines',
                        to: '/resellerpipelines'
                    },
                    {
                        label: 'Claim Form Users',
                        to: '/forms/users'
                    },
                    {
                        label: 'Repair Option Matrix',
                        to: '/repairoptions/matrix'
                    },
                    {
                        label: 'Repair Option Instructions',
                        to: '/repairoptions/instructions'
                    }
                ]
            }
        },
        computed: {
            hideSysAdmin() {
                return !this.userHasRole(userRoles.SYS_ADMIN)
            },
            showSidebarIcon() {
                if (this.manShowSidebar) {
                    return 'fas fa-angle-double-left'
                } else {
                    return 'fas fa-angle-double-right'
                }
            },
            claimsRoles() { return claimsRoles; }
        },
        methods: {
            getbucketIcon(to) {
                if (this.$route.fullPath == to) {
                    return 'far fa-folder-open'
                } else {
                    return 'far fa-folder'
                }
            },
            userHasAccess(viewByRoles) {
                if (viewByRoles && Array.isArray(viewByRoles)) {
                    for (var i = 0; i < viewByRoles.length; i++) {
                        if (this.$adminUser.hasRole(viewByRoles[i])) {
                            return true
                        }
                    }
                    return false
                } else {
                    return true
                }
            },
            hideSidebarClicked() {
                this.manShowSidebar = !this.manShowSidebar
                this.$emit('toggle-clicked', this.manShowSidebar)
            }
        }
    }
</script>

<style scoped>
</style>
